import { ExceptionsService } from './exceptions-service';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface CompanyClickedEvent {
  companyId         : number;
  onCancelled?      : (() => void) | undefined;
  onSaved           : ((sureSimCompanyId: number | undefined) => void) | undefined;
  openOnLocationTab?: boolean;
}

export interface IccidClickedEvent {
  iccid             : string;
  onCancelled?      : (() => void) | undefined;
  onSaved           : (() => void) | undefined;
  openOnLocationTab?: boolean;
}

export interface LocationServicesChangedEvent {
  iccid           : string | undefined;
  locationServices: boolean;
  sourceInstanceId: string;
  status          : 'requested' | 'completed' | 'failed';
}

export interface LocationServicesChangedEvent {
  iccid           : string | undefined;
  locationServices: boolean;
  sourceInstanceId: string;
  status          : 'requested' | 'completed' | 'failed';
}

/** RBW_20260414
 * GlobalEventService
 * Provides a cross-component broadcast channel for UI events
 * that cannot be handled via @Output() alone (e.g. map → sidebar).
 */
@Injectable({ providedIn: 'root' })

export class GlobalEventService {

  private accessGuidsChangedSubject     : Subject<void>                        =new Subject<void>();
  private companyClickedSubject         : Subject<CompanyClickedEvent>         =new Subject<CompanyClickedEvent>();
  private iccidClickedSubject           : Subject<IccidClickedEvent>           =new Subject<IccidClickedEvent>();
  private locationServicesChangedSubject: Subject<LocationServicesChangedEvent>=new Subject<LocationServicesChangedEvent>();

  constructor(
    private exceptionsService: ExceptionsService
  ) { }

  public broadcastAccessGuidsChanged(): void {
    try {
      this.accessGuidsChangedSubject.next();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public get accessGuidsChanged$(): Observable<void> {
    try {
      return this.accessGuidsChangedSubject.asObservable();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return new Observable<void>();
    }
  }

  public broadcastCompanyClicked(companyId: number, onSaved?: (sureSimCompanyId: number | undefined) => void, onCancelled?: () => void, openOnLocationTab: boolean = false): void {
    try {
      this.companyClickedSubject.next({ companyId, onCancelled, onSaved, openOnLocationTab });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public get companyClicked$(): Observable<CompanyClickedEvent> {
    try {
      return this.companyClickedSubject.asObservable();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return new Observable<CompanyClickedEvent>();
    }
  }

  public broadcastIccidClicked(iccid: string, onSaved?: () => void, onCancelled?: () => void, openOnLocationTab: boolean = false): void {
    try {
      this.iccidClickedSubject.next({ iccid, onCancelled, onSaved, openOnLocationTab });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public get iccidClicked$(): Observable<IccidClickedEvent> {
    try {
      return this.iccidClickedSubject.asObservable();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return new Observable<IccidClickedEvent>();
    }
  }

  public broadcastLocationServicesChanged(iccid: string | undefined, locationServices: boolean, sourceInstanceId: string, status: 'requested' | 'completed' | 'failed'): void {
    try {
      this.locationServicesChangedSubject.next({ iccid, locationServices, sourceInstanceId, status });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public get locationServicesChanged$(): Observable<LocationServicesChangedEvent> {
    try {
      return this.locationServicesChangedSubject.asObservable();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return new Observable<LocationServicesChangedEvent>();
    }
  }
}
